import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';
import { IPortalTaskToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	status: string | null;
	assignees: string[] | null;
	associatedTasks: IPortalTaskToLinkDTO[];
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	pageSize: 5,
	status: null,
	assignees: null,
	associatedTasks: [],
};

const portalMilestones = createSlice({
	name: 'portalMilestones',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStatus: (state, action: PayloadAction<{ status: string | null }>) => {
			state.status = action.payload.status;
			state.page = initialState.page;
		},
		setAssignees: (state, action: PayloadAction<{ assignees: string[] | null }>) => {
			state.assignees = action.payload.assignees;
			state.page = initialState.page;
		},
		setAssociatedTasks: (state, action: PayloadAction<{ associatedTasks: IPortalTaskToLinkDTO[] }>) => {
			state.associatedTasks = [...state.associatedTasks, ...action.payload.associatedTasks];
		},
		setAssociatedTask: (state, action: PayloadAction<{ associatedTask: IPortalTaskToLinkDTO }>) => {
			state.associatedTasks = [...state.associatedTasks, action.payload.associatedTask];
		},
		removeAssociatedTask: (state, action: PayloadAction<{ id: string }>) => {
			state.associatedTasks = state.associatedTasks.filter((task: IPortalTaskToLinkDTO) => {
				return task.id !== action.payload.id;
			});
		},
		clearAssociatedTasks: (state) => {
			state.associatedTasks = initialState.associatedTasks;
		},
		resetPortalMilestones: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setStatus,
	setAssociatedTasks,
	setAssociatedTask,
	removeAssociatedTask,
	clearAssociatedTasks,
	setAssignees,
	resetPortalMilestones,
} = portalMilestones.actions;

export default portalMilestones.reducer;
